import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar, PageEvent } from '@angular/material';
import { AirportService } from '../../airport/airport.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
var EditAddAirportComponent = /** @class */ (function () {
    function EditAddAirportComponent(dialogRef, data, airportService, _businessService, snackBar) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.airportService = airportService;
        this._businessService = _businessService;
        this.snackBar = snackBar;
        this._airportFilter = '';
        this._searchPrivateAirports = false;
        this.isLoading = false;
        this.pageLength = 5;
        this.business = data.business;
    }
    EditAddAirportComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(EditAddAirportComponent.prototype, "airportFilter", {
        get: function () {
            return this._airportFilter;
        },
        set: function (newFilter) {
            this._airportFilter = newFilter;
            this.loadAirports();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditAddAirportComponent.prototype, "searchPrivateAirports", {
        get: function () {
            return this._searchPrivateAirports;
        },
        set: function (newFilter) {
            this._searchPrivateAirports = newFilter;
            this.loadAirports();
        },
        enumerable: true,
        configurable: true
    });
    EditAddAirportComponent.prototype.loadAirports = function () {
        var _this = this;
        if (this.airportFilter.length >= 3) {
            this.isLoading = true;
            this.currentPage = [];
            this.airportService.getAirportsBySearchTerm(this.airportFilter, this.searchPrivateAirports)
                .then(function (airportList) {
                _this.searchedAirports = airportList;
                _this.isLoading = false;
                _this.doPageEvent({
                    pageIndex: 0,
                    pageSize: _this.pageLength,
                    length: _this.searchedAirports.length
                });
            })
                .catch(function (error) { return console.log(error); });
        }
    };
    EditAddAirportComponent.prototype.onAdd = function (airport) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var responseString, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this._businessService.addAssociatedAirport(this.business, airport.airportId)];
                    case 1:
                        responseString = _b.sent();
                        if (!responseString.includes('added to')) return [3 /*break*/, 3];
                        this.snackBar.open("Added " + airport.faaId + " to " + this.business.name, 'Close', {
                            duration: 5000
                        });
                        _a = this;
                        return [4 /*yield*/, this.airportService.getBusiness(this.business.id.toString())];
                    case 2:
                        _a.business = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        if (responseString.includes('already associated with')) {
                            this.snackBar.open(airport.faaId + " already associated with " + this.business.name, 'Close', {
                                duration: 5000
                            });
                        }
                        else {
                            this.snackBar.open("Failed to Add " + airport.faaId + " to " + this.business.name, 'Close', {
                                duration: 5000
                            });
                        }
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    EditAddAirportComponent.prototype.doPageEvent = function (event) {
        var start = event.pageIndex * event.pageSize;
        this.currentPage = this.searchedAirports.slice(start, start + event.pageSize);
    };
    return EditAddAirportComponent;
}());
export { EditAddAirportComponent };
